import { Icon } from './icon.tsx'
import type { IconName } from './icon.tsx'

export type ICustomIconButton = {
	name: IconName
	href: string
}

const CustomIconButton: React.FC<ICustomIconButton> = ({ name, href }) => (
	<a key={name} data-testid="link-component" href={href}>
		<button
			className="btn btn-icon-only btn-lg text-color-blue uds-zoom uds-zoom-in-hover me-4"
			type="button"
			data-testid={`follow-button-${name}`}
		>
			<Icon name={name} className="h-6 w-6" />
		</button>
	</a>
)

export default CustomIconButton
